import styled, { css } from 'styled-components';
import { onVerticalScreen } from '../../utils/css';
import { Theme } from '../../config/theme';

export enum ButtonVariantEnum {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

const BUTTON_COLORS = (theme: Theme) => ({
  [ButtonVariantEnum.PRIMARY]: {
    background: theme.colors.purple,
    border: theme.colors.purple,
  },
  [ButtonVariantEnum.SECONDARY]: {
    background: theme.colors.vividBlue,
    border: theme.colors.vividBlue,
  },
});

const BUTTON_ANIMATION_DURATION = 0.5;

export const ButtonElem = styled.button<{ variant?: ButtonVariantEnum }>`
  font-family: ${({ theme }) => theme.fonts.citiSans};
  background-color: ${({ theme, variant = ButtonVariantEnum.PRIMARY }) =>
    BUTTON_COLORS(theme)[variant].background ?? 'transparent'};
  border: ${({ theme, variant = ButtonVariantEnum.PRIMARY }) =>
    `${theme.getValue(3)} solid ${BUTTON_COLORS(theme)[variant].border ?? 'transparent'}`};
  outline: none;
  border-radius: ${({ theme }) => theme.getValue(10)};
  color: ${({ theme }) => theme.colors.white};
  padding: ${({ theme }) => `${theme.getValue(16)} ${theme.getValue(32)}`};
  font-size: ${({ theme }) => theme.getFontSize(18)};
  font-weight: 700;
  cursor: pointer;
  margin: ${({ theme }) => `${theme.getValue(8)} ${theme.getValue(16)}`};
  &:disabled {
    opacity: 0.6;
  }

  &.interstate {
    font-family: ${({ theme }) => theme.fonts.interstate};
  }

  &.pressed {
    animation: pressed-in ${BUTTON_ANIMATION_DURATION}s forwards;
  }
  &.notpressed {
    animation: pressed-out ${BUTTON_ANIMATION_DURATION}s forwards;
  }

  ${({ theme }) =>
    onVerticalScreen(css`
      font-size: ${`${theme.getFontSize(32)}`};
    `)}
`;

export const ButtonContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 2;

    @keyframes pressed-out {
      0% {
        top: ${theme.getValue(2)};
      }
      100% {
        top: 0;
      }
    }

    @keyframes pressed-in {
      0% {
        top: 0;
      }
      100% {
        top: ${theme.getValue(2)};
      }
    }
  `}
`;
